export default __webpack_public_path__ + "static/trackrecordimg_2-e2075703ff48b2649bc5eefd345b3759.png";